// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "questionAnswerCard-3jkxa";
var _4 = "questionAnswerCard__header-3NuP0";
var _5 = "questionAnswerCard__headerAction-1QBkS";
var _6 = "questionAnswerCard__headerTitle-3ZlNU";
var _7 = "questionAnswerCard__headerToggle-2mCHm";
var _8 = "questionAnswerCard__headerToggle_active-2b-V1";
var _9 = "questionAnswerCard__content-AIOgA";
export { _1 as "__esModule", _2 as "mobile", _3 as "questionAnswerCard", _4 as "questionAnswerCard__header", _5 as "questionAnswerCard__headerAction", _6 as "questionAnswerCard__headerTitle", _7 as "questionAnswerCard__headerToggle", _8 as "questionAnswerCard__headerToggle_active", _9 as "questionAnswerCard__content" }
export default { "__esModule": _1, "mobile": _2, "questionAnswerCard": _3, "questionAnswerCard__header": _4, "questionAnswerCard__headerAction": _5, "questionAnswerCard__headerTitle": _6, "questionAnswerCard__headerToggle": _7, "questionAnswerCard__headerToggle_active": _8, "questionAnswerCard__content": _9 }
